import React, { useEffect, useState } from 'react'
import { Button } from '@mui/material';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { CForm, CFormLabel, CFormTextarea, CRow } from '@coreui/react'
import { useAuth } from '../contexts/AuthContext';
import { useUserGroup } from '../contexts/UserGroupContext';
import CInput from './CInput';
import CSelect from './CSelect'

const roleOptionsList = [
    { label: 'admin', value: 'admin' },
    { label: 'staff', value: 'staff' }
];

function AddUserGroup({ visible, editMode, editUserGroupId, handleClose, fetchUserGroups, userGroupDetail, setUserGroupDetail, canCreate, canUpdate, canDelete }) {
    const { createUserGroup, updateUserGroup, getSingleUserGroups, deleteUserGroup } = useUserGroup();
    const { restaurantId } = useAuth()

    const [validated, setValidated] = useState(false);;

    useEffect(() => {
        if (editMode && editUserGroupId) fetchSingleUserGroup();
    }, [editMode, editUserGroupId]);

    const fetchSingleUserGroup = async () => {
        try {
            const userGroup = await getSingleUserGroups(editUserGroupId);
            setUserGroupDetail(userGroup);
        } catch (error) {
            console.error('Error fetching single user group', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if ((editMode && !canUpdate) || (!editMode && !canCreate)) return;

        const form = e.currentTarget;

        setValidated(true);
        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (visible && restaurantId) {
                    const data = await createUserGroup({ ...userGroupDetail, restaurant_id: restaurantId });
                    if (!data.error) {
                        fetchUserGroups(data.userGroup)
                        handleClose();
                        setUserGroupDetail({
                            name: '',
                            role: '',
                            description: '',
                            role_access: null,
                        })
                    }
                } else if (editMode && editUserGroupId && restaurantId) {
                    const data = await updateUserGroup(editUserGroupId, { ...userGroupDetail, restaurant_id: restaurantId });
                    if (!data.error) {
                        handleClose();
                        fetchUserGroups()
                        setUserGroupDetail({
                            name: '',
                            role: '',
                            description: '',
                            role_access: null,
                        })
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    const handleDelete = async () => {
        try {
            const confirmed = await confirmDelete();
            if (confirmed) {
                const data = await deleteUserGroup(editUserGroupId);
                if (data.error === false) {
                    handleClose();
                    setUserGroupDetail({
                        name: '',
                        role: '',
                        description: '',
                        role_access: null,
                    })
                    fetchUserGroups()
                }
            }
        } catch (error) {
            console.error('Error during delete operation', error);
        }
    };

    const confirmDelete = async () => {
        return new Promise((resolve) => {
            confirmDialog({
                message: 'Are you sure you want to delete this user group?',
                header: 'Delete Confirmation',
                icon: 'pi pi-info-circle',
                position: 'top',
                accept: () => resolve(true),
                reject: () => resolve(false),
            });
        });
    };
    return (
        <div>
            <ConfirmDialog />
            <Dialog draggable={false} header={`${visible ? 'Create User Group' : 'Edit User Group'}`} visible={visible || (editMode && editUserGroupId !== null)} style={{ width: '50vw' }} onHide={() => handleClose()}>
                <CForm onSubmit={handleSubmit} noValidate validated={validated} className='mt-4'>
                    <div className='fields-container'>
                        <CRow className="mb-3 mt-3">
                            <CInput
                                className='d-flex'
                                labelClassName='fw-normal w-50'
                                label="User Group Name"
                                type="text"
                                value={userGroupDetail.name}
                                onChange={(value) => setUserGroupDetail({ ...userGroupDetail, name: value })}
                                required={true}
                                errorMessage='Name of group is required.'
                            />
                        </CRow>
                        <CRow className="mb-3">
                            <CSelect
                                label="Role"
                                labelClassName='w-50'
                                className='d-flex'
                                value={userGroupDetail.role}
                                onChange={(value) => setUserGroupDetail({ ...userGroupDetail, role: value })}
                                options={roleOptionsList}
                                required={true}
                                errorMessage='Please select a valid role.'
                            />
                        </CRow>
                        <CRow className="mb-3">
                            <div className='d-flex'>
                                <div className='fw-normal w-50'>
                                    <CFormLabel>Description <span className="text-danger">*</span></CFormLabel>
                                </div>
                                <div className='w-100'>
                                    <CFormTextarea
                                        value={userGroupDetail.description}
                                        onChange={(e) => setUserGroupDetail({ ...userGroupDetail, description: e.target.value })}
                                        rows={2}
                                        required={true}
                                        feedbackInvalid='Group description is required.'
                                    />
                                </div>
                            </div>
                        </CRow>
                    </div>
                    <div className={`d-flex button-container ${(editMode && editUserGroupId && canDelete) ? 'justify-content-between' : 'justify-content-end'}`}>
                        {
                            (editMode && editUserGroupId && canDelete) && (
                                <div>
                                    <Button color='error' variant="contained" onClick={handleDelete} >
                                        Delete
                                    </Button>
                                </div>
                            )
                        }
                        <div className='d-flex'>
                            <Button onClick={() => handleClose()} fullWidth variant="contained" color="inherit" >
                                Cancel
                            </Button>
                            {((!editMode && canCreate) || (editMode && canUpdate)) && (
                                <Button fullWidth variant="contained" color="primary" type="submit" className="ms-3">
                                    Submit
                                </Button>
                            )}
                        </div>
                    </div>
                </CForm>
            </Dialog>
        </div>
    )
}

export default AddUserGroup